// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_exn from "../../../node_modules/rescript/lib/es6/js_exn.js";
import * as $$Promise from "../../../node_modules/@ryyppy/rescript-promise/lib/es6_global/src/Promise.bs.js";
import * as Belt_Array from "../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_format from "../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Env$Showside from "./utils/Env.bs.js";
import * as Shopify$Showside from "./utils/Shopify.bs.js";
import * as Analytics$Showside from "./utils/Analytics.bs.js";
import * as FetchUtils$Showside from "./utils/FetchUtils.bs.js";
import * as ShopifyConfig$Showside from "./utils/ShopifyConfig.bs.js";
import * as GoogleAnalytics$Showside from "./utils/GoogleAnalytics.bs.js";
import * as FirebaseAnalytics$Showside from "./utils/FirebaseAnalytics.bs.js";
import * as RescriptJsonUtils$Showside from "./utils/RescriptJsonUtils.bs.js";
import * as Account_PublicDecoders$ApiTypes from "../../../node_modules/api-types/lib/es6_global/src/Account/Account_PublicDecoders.bs.js";
function trackPurchase(order, shop, param) {
  var affiliation = shop !== undefined ? shop : Belt_Option.getWithDefault(Shopify$Showside.getShop(undefined), "");
  var items = Belt_Array.map(order.line_items, function (item) {
    return {
      affiliation: affiliation,
      id: String(item.product_id),
      name: item.title,
      price: item.price,
      quantity: item.quantity,
      variant: item.sku
    };
  });
  var purchase_transaction_id = order.order_id;
  var purchase_currency = order.currency;
  var purchase_value = order.total_price;
  var purchase = {
    affiliation: affiliation,
    transaction_id: purchase_transaction_id,
    currency: purchase_currency,
    value: purchase_value,
    items: items
  };
  FirebaseAnalytics$Showside.init(undefined).then(function (firebase) {
    FirebaseAnalytics$Showside.logEvent(firebase, "purchase", purchase);
    FirebaseAnalytics$Showside.logValueEvent(firebase, "smart_nav_purchase", purchase, Caml_format.float_of_string(order.total_price));
    Belt_Array.forEach(items, function (item) {
      FirebaseAnalytics$Showside.logValueEvent(firebase, "smart_nav_purchase_product", item, Caml_format.float_of_string(item.price) * item.quantity);
    });
  });
}
function setUserId(param) {
  $$Promise.$$catch(ShopifyConfig$Showside.load(Env$Showside.apiHostnameProduction).then(function (config) {
    var accountId = config.accountId;
    if (accountId !== undefined) {
      return FetchUtils$Showside.$$fetch(undefined, undefined, undefined, undefined, undefined, async function (json) {
        return RescriptJsonUtils$Showside.decode(json, Account_PublicDecoders$ApiTypes.Public.fromJson);
      }, Env$Showside.apiHostnameProduction + "/api/get_public_account?account_id=" + accountId).then(function (account) {
        return [config, account];
      });
    } else {
      return Promise.reject(Js_exn.raiseError("Config not found"));
    }
  }).then(function (param) {
    var config = param[0];
    GoogleAnalytics$Showside.init(config.settings.gaTrackingId, config.settings.gaVersion, config.settings.checkoutLink, undefined, param[1]);
  }), function (param) {
    return Promise.resolve(undefined);
  });
}
function init(param) {
  try {
    setUserId(undefined);
  } catch (exn) {}
  var order = Belt_Option.flatMap(window.Shopify, function (shopify) {
    return shopify.checkout;
  });
  var wasPostPurchasePageSeen = Belt_Option.getWithDefault(Belt_Option.flatMap(window.Shopify, function (shopify) {
    return shopify.wasPostPurchasePageSeen;
  }), false);
  var match = Analytics$Showside.isEnabled(undefined);
  if (match && order !== undefined && !wasPostPurchasePageSeen) {
    return trackPurchase(order, undefined, undefined);
  }
}
export { trackPurchase, setUserId, init };
/* Env-Showside Not a pure module */